import * as React from 'react'
import Table from 'react-bootstrap/Table'

function Medium(props) {

  return (
    <React.Fragment>
        <div className="dataTable proceso-info-t-m">
            <Table striped bordered hover>
                    <tbody>
                        <tr>
                            <td className="highlight row25">Tipo de Proceso</td>
                            <td className="row25">{JSON.stringify(props.caseInfo.tipo_proceso).slice(1,-1)}</td>
                            <td className="highlight row25">Clase</td>
                            <td className="row25">{JSON.stringify(props.caseInfo.clase).slice(1,-1)}</td>
                        </tr>

                        <tr>
                            <td className="highlight row25">Demandante</td>
                            <td className="row25">{JSON.stringify(props.caseInfo.demandantes).slice(1,-1)}</td>
                            <td className="highlight row25">Demandado</td>
                            <td className="row25">{JSON.stringify(props.caseInfo.demandados).slice(1,-1)}</td>
                        </tr>
                        <tr>
                            <td className="highlight row25">Despacho</td>
                            <td className="row25">{JSON.stringify(props.caseInfo.despacho).slice(1,-1)}</td>
                            <td className="highlight row25">Recurso</td>
                            <td className="row25">{JSON.stringify(props.caseInfo.tipo_recurso).slice(1,-1)}</td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="highlight">Fecha de Radicacion</td>
                            <td colSpan="2">{JSON.stringify(props.caseInfo.fecha).slice(1,-1)}</td>
                        </tr>
                        <tr>
                            <td colSpan="4" className="highlight">Contenido de Radicacion</td>
                        </tr>
                        <tr>
                            <td colSpan="4">{JSON.stringify(props.caseInfo.contenido).slice(1,-1)}</td>
                        </tr>
                    </tbody>
                </Table>  
            </div>   
    </React.Fragment>
  );
}

export { Medium };
